export class AppSettings {
 // public static API_ENDPOINT='http://localhost:7071/';
 //  public static API_ENDPOINT = 'https://parumalachurchfunctionstest.azurewebsites.net/';
    public static API_ENDPOINT = 'https://malankaraorthodoxchurch.azurewebsites.net/';
  public static mainUrl = 'https://www.madrasdiocese.org/';
  public static MalankaraCommonApi ='https://malankaraorthodoxchurchfunctions.azurewebsites.net/';


}
